<template>
  <b-container>
    <canvas ref="pie-chart" width="160" height="90" />
  </b-container>
</template>

<script>
import _ from 'lodash'
import Chart from 'chart.js'

import chartColors from '@/components/chart_colors.js'

// *****************************************************************************

class PieChart {
  constructor(el, title, label_array) {
    this.el = el
    this.title = title
    this.labels = label_array
  }
  init() {
    this.real_chart = new Chart(this.el, {
      type: 'pie',
      data: {
        datasets: [],
        // Don't know why labels are here and not in the chartjs sample
        labels: this.labels,
      },
      options: {
        responsive: true,
        title: {
          display: true,
          text: this.title,
        },
        labels: {
          render: 'value',
          fontColor: '#000',
        },
        legend: {
          position: 'right',
        },
        plugins: {
          datalabels: {
            display: true,
          },
        },
      },
    })
  }
  update_datasets(datasets) {
    this.real_chart.data.datasets = datasets
    this.real_chart.update()
  }
  update_labels(labels) {
    this.real_chart.data.labels = labels
    this.real_chart.update()
  }
}

// *****************************************************************************

export default {
  name: 'SimpleDynamicPieChart',
  props: ['chart_title', 'data_array', 'label_array'],
  data() {
    return {
      chart_object: undefined,
    }
  },
  computed: {
    title() {
      return this.$t(this.chart_title)
    },
    // N.B PL : Do we need to put this in a props ?
    background_colors() {
      let res = [
        chartColors.danger,
        chartColors.orange,
        chartColors.warning,
        chartColors.info,
      ]
      return res
    },
  },
  watch: {
    data_array(new_val, old_val) {
      if (_.isUndefined(this.chart_object)) {
        return
      }
      let new_datasets = this.build_new_datasets(new_val)
      this.chart_object.update_datasets(new_datasets)
    },
    data_labels(nv, ov) {
      if (_.isUndefined(this.chart_object)) {
        return
      }
      this.chart_object.update_labels(nv)
    },
  },
  mounted() {
    if (_.isUndefined(this.chart_object)) {
      this.chart_object = new PieChart(
        this.$refs['pie-chart'],
        this.title,
        this.label_array
      )
      this.chart_object.init()
      let new_datasets = this.build_new_datasets(this.data_array)
      this.chart_object.update_datasets(new_datasets)
    }
  },
  beforeDestroy() {
    if (this.chart_object) {
      this.chart_object.real_chart.destroy()
      this.chart_object = undefined
    }
  },
  methods: {
    build_new_datasets(new_dataset) {
      // N.B PL : If we pass colors as a prop, we need to do a different check
      let n = _.size(new_dataset)
      let res = [{ data: new_dataset, backgroundColor: this.background_colors }]
      return res
    },
  },
}
</script>
